import { POST, GET } from "./http"
// , GET, DElETE
export default {
  saveUser: (data) => POST("/main/saveUser", data),
  saveAdmin: (data) => POST("/main/saveAdmin", data),
  getNews: (data) => GET("/main/newsList", data),
  getNewsById: (data) => POST("/main/getNewsById", data),
  saveNews: (data) => POST("/main/saveNews", data),
  deleteNews: (id) => POST("/main/deleteNews", { id }),
  // 产品,
  productList: (data) => GET("/main/productList", data),
  productById: (data) => POST("/main/getProduct", data),

  productSave: (data) => POST("/main/saveProduct", data),
  // 管理系统
  login: (data) =>
    POST("/main/login", data).then((res) => {
      if (res.code === 200) {
        sessionStorage.setItem("user", JSON.stringify(res.data))
      }
      return res
    }),
  // 获取用户信息
  getUserList: () => GET("/main/userList"),
}
